/* eslint-disable import/no-anonymous-default-export */

import dictionary from "../util/dictionary";
import apiCall from "./apiCall";

 const apiHost=dictionary.apiHost;
const ACCESS_TOKEN = localStorage.getItem('yexp@user');

export default {
   
    async listExpenseAccounts()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'expense/accounts/list',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },

    async listPaymentAccounts()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'expense/payment-accounts/list',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },
    async addExpense(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag)
    {

        let data={
            "trail_account":paymentAccount,
            "target_account":targetAccount,
            "amount":amount,
            "transaction_date":transactionDate,
            "description":description,
            "payee":payee,
            "transaction_reference":transactionRef,
            "tag":tag
        }

        const response = await apiCall("expense/add", data);
        return response;

    },

    async getExpenseBalance()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'expense/balance',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },

    async listExpenseBalances()
    {

        let data={
            "source":"Web",
        }
        try{
            let response= await fetch(apiHost + 'expense/balances/list',
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Accept': 'application/json', 
                    'Content-Type': 'application/json',
                    'Source': 'Admin'
                },
                body:JSON.stringify(data),
            });

                let result= await response.json();

                return result;
            }catch(error)
            {
                let connError={'status':'conn', 'details':['Contacting server....']}
                return connError;
            }

    },



    async fetchInvoiceRecords(data){
    
        let response = await apiCall("expense/invoicing/list", data);
        return response;
    },



    async createInvoice(data){
    
        let response = await apiCall("expense/invoicing/create", data);
        return response;
    },


    async PayInvoice(data){
    
        let response = await apiCall("expense/invoicing/pay", data);
        return response;
    },


} 